import type { Goal, Quantity } from '@medplum/fhirtypes';

const COMPARATOR_SYMBOLS: Record<string, string> = {
  '<': '<',
  '<=': '≤',
  '>=': '≥',
  '>': '>',
};

function formatTargetQuantity(detail: Quantity): string {
  const comparator = detail.comparator
    ? COMPARATOR_SYMBOLS[detail.comparator]
    : undefined;
  const unit = detail.unit && !detail.unit.startsWith('{') ? detail.unit : '';
  const amount =
    unit === '%'
      ? `${detail.value}%`
      : `${detail.value}${unit ? ` ${unit}` : ''}`;
  return [comparator, amount].filter(Boolean).join(' ');
}

/**
 * Display text for a goal's measurable target: "≤ 2", "≥ 30 s", "22–28 %",
 * or the agent's free-text detailString verbatim.
 */
export function formatGoalTarget(goal: Goal): string | undefined {
  const target = goal.target?.[0];
  if (!target) return undefined;
  if (target.detailQuantity?.value !== undefined) {
    return formatTargetQuantity(target.detailQuantity);
  }
  const low = target.detailRange?.low;
  const high = target.detailRange?.high;
  if (low?.value !== undefined && high?.value !== undefined) {
    return `${low.value}–${formatTargetQuantity(high)}`;
  }
  return target.detailString;
}
